import {createAsyncThunk} from '@reduxjs/toolkit';
import {filtersApi} from 'api';
import {IBindBaseEntity} from 'models';
import {toastNotificationManager} from 'toast-notifications';
import {prefix} from './config';

export const fetchEthnicitiesThunk: any = createAsyncThunk<IBindBaseEntity[]>(
  `${prefix} fetchEthnicities`,
  async (_, {rejectWithValue, dispatch}) => {
    try {
      const {parsedBody} = await filtersApi.getPerceivedEthnicities();
      return parsedBody;
    } catch (error) {
      dispatch(
        toastNotificationManager.createErrorToastAction(
          error.parsedBody || error.statusText || 'Failed to fetch ethnicities. Unknown error occurred.'
        )
      );
      return rejectWithValue(error);
    }
  }
);
